import { Controller } from 'stimulus'

export default class extends Controller {
  scrollTo(event) {
    const query = event.detail.scrollTo
    if (query) {
      const queryResult = document.querySelectorAll(query)
      if (queryResult.length > 0) {
        const elementToScroll = queryResult[0]
        elementToScroll.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    }
  }
}
